import type { SequencerOptions } from "./types";

export const DEFAULT_SEQUENCER_OPTIONS: SequencerOptions = {
    skipToFirstNoteOn: true,
    initialPlaybackRate: 1
};
